(function () {
  function initialize(root) {
    if (root.dataset.carouselReady === 'true') return;
    const slides = Array.from(root.querySelectorAll('[data-main-slide]'));
    const gallery = root.closest('.shp-gallery');
    const dots = gallery ? Array.from(gallery.querySelectorAll('[data-main-dot]')) : [];
    const previousButton = root.querySelector('[data-main-prev]');
    const nextButton = root.querySelector('[data-main-next]');
    root.dataset.carouselReady = 'true';

    if (slides.length < 2) {
      previousButton?.setAttribute('hidden', '');
      nextButton?.setAttribute('hidden', '');
      return;
    }

    let index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    let timer = null;
    let startX = null;

    const show = function (next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach(function (dot, i) {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    const stop = function () {
      window.clearInterval(timer);
      timer = null;
    };
    const start = function () {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !document.hidden) {
        timer = window.setInterval(function () { show(index + 1); }, 3500);
      }
    };
    const interact = function (next) { show(next); start(); };

    previousButton?.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      interact(index - 1);
    });
    nextButton?.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      interact(index + 1);
    });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { interact(i); });
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      interact(index + (event.key === 'ArrowRight' ? 1 : -1));
    });
    root.addEventListener('pointerdown', function (event) {
      if (event.button !== 0 || event.target.closest('button')) return;
      startX = event.clientX;
      stop();
      root.setPointerCapture?.(event.pointerId);
    });
    root.addEventListener('pointerup', function (event) {
      if (startX === null) return;
      const distance = event.clientX - startX;
      startX = null;
      if (Math.abs(distance) >= 35) show(index + (distance < 0 ? 1 : -1));
      start();
    });
    root.addEventListener('pointercancel', function () { startX = null; start(); });
    if (!root.closest('steelhome-shelf-product')) root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    show(index);
    start();
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll('[data-steelhome-main-carousel]').forEach(initialize);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
})();
